// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './root'
import { Route as brandRoutesLayoutRouteImport } from './brand/routes/layout'
import { Route as brandRoutesHomeRouteImport } from './brand/routes/home'
import { Route as blogRoutesIndexRouteImport } from './blog/routes/index'
import { Route as newsletterRoutesConfirmRouteImport } from './newsletter/routes/confirm'
import { Route as blogRoutesPostRouteImport } from './blog/routes/post'
import { Route as brandRoutesLegalRouteImport } from './brand/routes/legal'

const brandRoutesLayoutRoute = brandRoutesLayoutRouteImport.update({
            id: '/_brand-layout',getParentRoute: () => rootRouteImport
          })
const brandRoutesHomeRoute = brandRoutesHomeRouteImport.update({
            id: '/',path: '/',getParentRoute: () => brandRoutesLayoutRoute
          })
const blogRoutesIndexRoute = blogRoutesIndexRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => brandRoutesLayoutRoute
          })
const newsletterRoutesConfirmRoute = newsletterRoutesConfirmRouteImport.update({
            id: '/newsletter/confirm',path: '/newsletter/confirm',getParentRoute: () => rootRouteImport
          })
const blogRoutesPostRoute = blogRoutesPostRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => brandRoutesLayoutRoute
          })
const brandRoutesLegalRoute = brandRoutesLegalRouteImport.update({
            id: '/legal/$slug',path: '/legal/$slug',getParentRoute: () => brandRoutesLayoutRoute
          })





const brandRoutesLayoutRouteChildren = {
  brandRoutesHomeRoute: brandRoutesHomeRoute,blogRoutesIndexRoute: blogRoutesIndexRoute,blogRoutesPostRoute: blogRoutesPostRoute,brandRoutesLegalRoute: brandRoutesLegalRoute
}

const brandRoutesLayoutRouteWithChildren = brandRoutesLayoutRoute._addFileChildren(brandRoutesLayoutRouteChildren)

const rootRouteChildren = {
  brandRoutesLayoutRoute: brandRoutesLayoutRouteWithChildren,newsletterRoutesConfirmRoute: newsletterRoutesConfirmRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)